import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RDService {

  rdURL = 'https://127.0.0.1:11100/';
  captureURL = 'https://127.0.0.1:11100/rd/capture';

  constructor() { }

  getPidDataForBiometricEKYC(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getRdServiceStatus().then(response => {
        if(response === 'READY'){}
        this.captureBiometricData().then(pidData => {
          resolve(pidData);
        }).catch(error => {
          reject(error);
        })
      }).catch(error => {
        reject(error)
      });
    });
  }

  captureBiometricData() {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('CAPTURE', this.captureURL, true);
      const inputXML = '<PidOptions> <Opts fCount=\"1\" fType=\"2\" iCount=\"0\" pCount=\"0\" format=\"0\" pidVer=\"2.0\" timeout=\"20000\" otp=\"\" posh=\"UNKNOWN\" env=\"P\" wadh=\"RZ+k4w9ySTzOibQdDHPzCFqrKScZ74b3EibKYy1WyGw=\" /> <Demo></Demo><CustOpts> <Param name=\"ValidationKey\" value=\"\" /> </CustOpts> </PidOptions>'
      xhr.responseType = 'text';
      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve(xhr.response);
        } else {
          reject('Failed to capture biometric data.');
        }
      };

      xhr.onerror = () => reject('Failed to capture biometric data.');
      xhr.send(inputXML);
    });
  }

  getRdServiceStatus(): Promise<any> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('RDSERVICE', this.rdURL, true);
      xhr.onload = () => {
        if (xhr.status === 200) {
          const xmlDoc = xhr.responseXML;
          const item = xmlDoc.getElementsByTagName('RDService')
          const status = item[0].getAttribute('status');
          resolve(status);
        } else {
          reject('RD Service is not found. please make sure appropriate RD Service is installed.');
        }
      };

      xhr.onerror = () => reject('RD Service not found.');
      xhr.send();
    });
  }

  prepareXmlForJson(xml: string): string {
    // Step 1: Remove line breaks (\r, \n)
    let cleanedXml = xml.replace(/(\r\n|\n|\r)/g, '');

     // Step 2: Remove unnecessary spaces inside tags
     cleanedXml = cleanedXml.replace(/>\s+</g, '><'); // Remove spaces between tags
     cleanedXml = cleanedXml.replace(/>\s+/g, '>');  // Remove spaces after a closing tag
     cleanedXml = cleanedXml.replace(/\s+</g, '<');  // Remove spaces before an opening tag

     // Step 3: Normalize multiple spaces within tag content
    cleanedXml = cleanedXml.replace(/\s{2,}/g, ' '); // Replace multiple spaces with a single space

    // Step 4: Trim leading and trailing spaces (just in case)
    cleanedXml = cleanedXml.trim();
    
    return cleanedXml;
  }
}
